export { default } from "./RegisteredPerson";
